<div class="gt">

  <!-- Search + select + date filters -->
  <div class="gt__filters">
    @for (f of toolbarFilters; track (f.key ?? f.field)) {
      @if (f.type === 'date') {
        <!-- Date range input -->
        <div class="gt__date-wrap">
          @if (f.label) { <span class="gt__date-label">{{ f.label }}</span> }
          <input
            type="date"
            class="gt__date"
            [(ngModel)]="values[f.key ?? f.field]"
            (ngModelChange)="onDateChange()"
            [attr.aria-label]="f.label ?? f.field"
          />
        </div>
      } @else if (f.options) {
        <!-- Select filter -->
        <select
          class="gt__select"
          [(ngModel)]="values[f.key ?? f.field]"
          (ngModelChange)="onSelectChange()"
          [attr.aria-label]="f.label ?? f.field"
        >
          <option value="">{{ f.label ?? 'Todos' }}</option>
          @for (opt of f.options; track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      } @else {
        <!-- Text search with icon -->
        <div class="gt__search-wrap">
          <i class="bi bi-search gt__search-icon" aria-hidden="true"></i>
          <input
            type="text"
            class="gt__search"
            [placeholder]="f.placeholder ?? 'Filtrar…'"
            [(ngModel)]="values[f.key ?? f.field]"
            (ngModelChange)="onTextChange()"
            [attr.aria-label]="f.label ?? f.placeholder ?? f.field"
          />
          @if (values[f.key ?? f.field]) {
            <button
              type="button"
              class="gt__clear"
              (click)="values[f.key ?? f.field] = ''; onTextChange()"
              aria-label="Limpar"
            >
              <i class="bi bi-x" aria-hidden="true"></i>
            </button>
          }
        </div>
      }
    }
    @if (hasActiveFilters) {
      <button type="button" class="gt__clear-all" (click)="clearAll()" title="Limpar todos os filtros">
        <i class="bi bi-x-circle" aria-hidden="true"></i> Limpar
      </button>
    }
  </div>

  <!-- Export dropdown -->
  @if (showExport) {
    <div class="gt__export-wrap">
      <button
        type="button"
        class="gt__export"
        (click)="toggleExportMenu()"
        [class.gt__export--open]="exportOpen"
        aria-haspopup="true"
        [attr.aria-expanded]="exportOpen"
        aria-label="Exportar dados"
      >
        <i class="bi bi-download" aria-hidden="true"></i>
        Exportar
        <i class="bi bi-chevron-down gt__export-chevron" aria-hidden="true"></i>
      </button>
      @if (exportOpen) {
        <div class="gt__export-menu" role="menu">
          <button type="button" class="gt__export-item" role="menuitem" (click)="onExport('csv')">
            <i class="bi bi-filetype-csv"></i> CSV
          </button>
          <button type="button" class="gt__export-item" role="menuitem" (click)="onExport('xlsx')">
            <i class="bi bi-file-earmark-spreadsheet"></i> Excel (.xlsx)
          </button>
        </div>
      }
    </div>
  }

</div>
